import { initializeApp } from 'firebase/app';
import { getAuth, signOut } from 'firebase/auth';
import { setFirebaseBridge } from 'coupon-common/src/modules/auth/firebaseBridge';

// Public client config — safe to keep in source, same values used by the mobile app's Firebase project.
// Prod
const firebaseConfig = {
  apiKey: "AIzaSyBJSeYLYGfAwKkYyv0LdSIMeSP_3LxTGCU",
  authDomain: "my-couponbook---prod.firebaseapp.com",
  projectId: "my-couponbook---prod",
  storageBucket: "my-couponbook---prod.firebasestorage.app",
  messagingSenderId: "1037087430576",
  appId: "1:1037087430576:web:5c367b912d9532753e6875",
  measurementId: "G-S0H62STZT8"
};
// // STAGING
// const firebaseConfig = {
//   apiKey: "AIzaSyDCAGzxqt2Xq5aKyLFiaG5WgcoCpaQQa-Q",
//   authDomain: "fresh-catwalk-215023.firebaseapp.com",
//   projectId: "fresh-catwalk-215023",
//   storageBucket: "fresh-catwalk-215023.firebasestorage.app",
//   messagingSenderId: "896738615041",
//   appId: "1:896738615041:web:f0cfd6b8d9068217b60500",
//   measurementId: "G-4JSC8FW0SV"
// };

const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);

// Lets coupon-common refresh Firebase ID tokens and sign out without
// importing the Firebase SDK itself. Registered on import — App.js imports
// this file so it is always loaded.
setFirebaseBridge({
  getIdToken: async () => {
    // Wait for the persisted session to load after a page reload.
    if (firebaseAuth.authStateReady) {
      await firebaseAuth.authStateReady();
    }
    return firebaseAuth.currentUser ? firebaseAuth.currentUser.getIdToken() : null;
  },
  signOut: () => signOut(firebaseAuth),
});

export default firebaseApp;